import React, { useRef } from "react";
import {
  Chart,
  Series,
  ArgumentAxis,
  ValueAxis,
  Legend,
  Tooltip,
  Label,
  CommonSeriesSettings,
} from "devextreme-react/chart";
import ChartCard from "components/common/pyramid/ChartCard";

const AmortizationByMaturity = ({ data, palette, title }) => {
  const chartRef = useRef(null);

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const customizeTooltip = (arg) => {
    const pointData = arg.point?.data || {};
    const amortization = pointData.amortization || 0;
    const remainingDiscount = pointData.remainingDiscount || 0;
    const initialDiscount = pointData.initialDiscount || 0;

    return {
      html: `
        <div style="padding: 10px;">
          <div style="font-weight: bold; margin-bottom: 5px;">${
            arg.argumentText
          }</div>
          <div><span style="font-weight: 600;">Initial Discount</span>: ${formatter.format(
            initialDiscount
          )}</div>
          <div><span style="font-weight: 600;">Amortization</span>: ${formatter.format(
            amortization
          )}</div>
          <div><span style="font-weight: 600;">Remaining Discount</span>: ${formatter.format(
            remainingDiscount
          )}</div>
        </div>
      `,
    };
  };

  return (
    <ChartCard
      title={title || "Amortization by Maturity"}
      chartRef={chartRef}
      palette={palette}
    >
      <div className="p-4">
        <Chart
          dataSource={data}
          id="amortizationByMaturityChart"
          ref={chartRef}
          palette={palette}
        >
          <CommonSeriesSettings type="stackedbar" />
          <Series
            valueField="amortization"
            argumentField="interval"
            name="Amortization"
            stack="amortizationStack"
          />
          <Series
            valueField="remainingDiscount"
            argumentField="interval"
            name="Remaining Discount"
            stack="amortizationStack"
          />
          <ArgumentAxis>
            <Label
              wordWrap="normal"
              textOverflow="ellipsis"
              overlappingBehavior="rotate"
              rotationAngle={45}
            />
          </ArgumentAxis>
          <ValueAxis />
          <Legend
            visible={true}
            horizontalAlignment="center"
            verticalAlignment="bottom"
          />
          <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip}
            format="fixedPoint"
            precision={2}
          />
        </Chart>
      </div>
    </ChartCard>
  );
};

export default AmortizationByMaturity;
